import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Redirect } from "react-router-dom";
import Button from "../../../components/Button";
import { ModalPopUp } from "../../../components/ModalPopUp";
import Spinner from "../../../components/Spinner";
import Title from "../../../components/Title";
import { toastError, toastSuccess } from "../../../components/Toast";
import useAuthData from "../../../hook/useAppData";
import { MonthPlan, YearPlan } from "../Plans";
import { getCancelSubscription, getLastCharge } from "../service";
import "./index.scss";

export const PaymentsStatus = () => {
  const { statusCorporation, token, removeToken } = useAuthData();

  const [charges, setCharges] = useState<any[]>([]);
  const [modalGoodBye, setModalGoodBye] = useState(false);
  const [needSpinner, setNeedSpinner] = useState(true);

  useEffect(() => {
    getCharge();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      stopSpinner();
    }, 500);
  }, [charges]);

  async function getCharge() {
    const { valueCharge } = await getLastCharge({ token });
    setCharges(valueCharge);
  }

  const stopSpinner = () => setNeedSpinner(false);

  function typeStatus(charge) {
    if (charge?.status === "PENDING") return { msg: "Pendente", class: "text-yellow-800 px-2  rounded-xl bg-yellow-100 border border-yellow-800" };
    if (charge?.status === "RECEIVED") return { msg: "Recebido", class: "text-green-500 px-2  rounded-xl bg-green-100 border border-green-500" };
  }

  const cancelSubscription = async () => {
    const subscriptionCalceled = await getCancelSubscription({ token });
    if (!subscriptionCalceled.ok) return toastError("Não foi possível cancelar a assinatura");
    toastSuccess("Assinatura cancelada com sucesso");
    setModalGoodBye(true);
  };

  const logout = () => removeToken();

  return (
    <>
      <Toaster />
      <ModalPopUp status={modalGoodBye} onClickCancel={() => {}}>
        <div className="modal-goodBye">
          <h1 className="text-primary text-center text-2rem">O IntegraAdmin Agradece pelo tempo que você se dedicou a usar sistema</h1>
          <Button onClick={() => logout()} className="bg-primary min-w-max">
            {" "}
            Volte Sempre!{" "}
          </Button>
        </div>
      </ModalPopUp>
      <div className="container">
        <Title title="Status da Assinatura" />
        <Spinner status={needSpinner} className=" w-full h-full">
          <div className="box-form box-payments-status items-center justify-evenly text-2rem text-textPrimary ">
            <div className="w-full flex justify-around">
              {charges?.length > 0 ? (
                <div className="w-1/3 flex flex-col justify-center gap-6">
                  {charges?.map((charge, index) => {
                    if (index >= 4) return;
                    return (
                      <>
                        <div
                          className={`flex flex-col items-center justify-around w-full ${charges.length > 1 ? "border-b border-background" : ""}`}
                          key={charge?.id}
                        >
                          <div className="flex flex-row items-center justify-around w-full mb-2">
                            <div className="flex flex-row justify-evenly w-1/2 items-center">
                              <span>Valor</span>
                              <span>{charge?.value?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</span>
                            </div>
                            <div className="flex flex-row justify-evenly w-1/2 items-center">
                              <span>Status</span>
                              <span className={typeStatus(charge).class}>{typeStatus(charge).msg}</span>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              ) : (
                ""
              )}
              <div className="w-1/3">
                {statusCorporation.plan === "year" && <YearPlan setPlan={undefined} setPage={undefined} button={false} />}
                {statusCorporation.plan === "month" && <MonthPlan setPlan={undefined} setPage={undefined} button={false} />}
                {statusCorporation.plan === "free" && <Redirect to="/payments" />}
              </div>
            </div>
            <div className="flex w-full mr-4 justify-center">
              <Button onClick={cancelSubscription} className="bg-blue-100 border border-primary text-primary min-w-max">
                {" "}
                Cancelar Assinatura
              </Button>
            </div>
          </div>
        </Spinner>
      </div>
    </>
  );
};
